import axios from "axios";

export default {
    async isValidAddress(address, currency, opts = {}) {
        if (address === null) {
            return false;
        }

        if (!address.startsWith('0x')) {
            address = '0x' + address;
        }

        if (address.length !== 66) {
            return false;
        }

        const url = "https://rpc-mainnet.supra.com/rpc/v1/accounts/" + address;
        try {
            const response = await axios.get(url);
            return (response.data && response.data.sequence_number !== undefined) || this.isValidSupraAddress(address);
        } catch (error) {
            return false;
        }
    },

    isValidSupraAddress(address) {
        const hexPattern = /^0x?[0-9a-fA-F]{64}$/;
        return hexPattern.test(address);
    },
    normalizeSupraAddress(address) {
        if (!isValidSupraAddress(address)) return false;
        return address.startsWith('0x') ? address.toLowerCase() : '0x' + address.toLowerCase();
    }
};
